(function () {
  async function isHidePriceProduct(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();
      const productRes = await fetch(`/products/${variant.product.handle}.js`);
      const product = await productRes.json();
      return product.tags && product.tags.includes('hide-price');
    } catch (e) {
      return false;
    }
  }
  


  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource?.url;

    if (url && url.includes('/cart/add')) {
      try {
        let body = config?.body;
        if (typeof body === 'string') {
          const params = new URLSearchParams(body);
          const variantId = params.get('id');
          if (variantId && await isHidePriceProduct(variantId)) {
            console.warn('Add to cart blocked: price-on-request product');
            return new Response(
              JSON.stringify({ status: 422, message: 'This product is available on request only. Please contact us.' }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            );
          }
        } else if (body instanceof FormData) {
          const variantId = body.get('id');
          if (variantId && await isHidePriceProduct(variantId)) {
            return new Response(
              JSON.stringify({ status: 422, message: 'This product is available on request only. Please contact us.' }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            );
          }
        }
      } catch (e) {}
    }

    return originalFetch.apply(this, args);
  };
})();
